import { render } from "./TasksModal.vue?vue&type=template&id=285862bd"
import script from "./TasksModal.vue?vue&type=script&lang=js"
export * from "./TasksModal.vue?vue&type=script&lang=js"

import "./TasksModal.vue?vue&type=style&index=0&id=285862bd&lang=css"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__